import { css, Skeleton as MuiSkeleton, styled } from '@mui/material';

import { SHAPE_MAP } from './constants';
import { skeletonClasses, TEXT_SHAPE_SIZE_MAP } from './theme';

import type { SkeletonOwnerState, SkeletonProps } from './types';

const Skeleton = (props: SkeletonProps) => {
  const { className, animation = 'wave', shape = 'text', size = 'md', ...others } = props;

  const ownerState: SkeletonOwnerState = {
    ...props,
    animation,
    shape,
    size,
  };

  return (
    <SkeletonRoot
      className={className}
      ownerState={ownerState}
      variant={SHAPE_MAP[shape]}
      animation={animation}
      {...others}
    />
  );
};

export default Skeleton;

Skeleton.displayName = 'Skeleton';

const SkeletonRoot = styled(MuiSkeleton, {
  target: skeletonClasses.root,
})<{ ownerState: SkeletonOwnerState }>(
  ({ theme, ownerState }) => css`
    background-color: ${theme.color['surface/neutral/weak/default']};
    ${getSkeletonShapeSizeStyle({ shape: ownerState.shape, size: ownerState.size })}
  `,
);

const getSkeletonShapeSizeStyle = ({ shape, size }: Pick<SkeletonOwnerState, 'shape' | 'size'>) => {
  if (shape === 'rectangle') {
    return css`
      border-radius: 4px;
    `;
  }

  if (shape === 'rounded') {
    return css`
      border-radius: 12px;
    `;
  }

  if (shape === 'text') {
    return css`
      border-radius: 4px;
      font-size: ${TEXT_SHAPE_SIZE_MAP[size]}px;
      transform: scale(1, 1);
    `;
  }

  return '';
};
